import moment from "moment-timezone";

import timezoneService from '../services/timezone.service';
import localdataService from '../services/localdata.service'

const utcTimezone = {
    id: 'UTC',
    name: 'UTC',
    desc: 'UTC (+00:00)',
    offset: 0
};

const handlers = {
    timezones: {
        set: 'timezones_set',
        add: 'timezones_add'
    },
    currentTimezone: {
        set: 'currentTimezone_set'
    }
};

const initVuexState = function(state) {
    state.timezones = [];
    state.currentTimezone = null;
};

const initGetters = function(getters) {
    getters.timezones = state => state.timezones;
    getters.currentTimezone = state => state.currentTimezone;
};

const initActions = function(actions) {
    actions[handlers.timezones.set] = ({ commit }, timezones) => commit(handlers.timezones.set, timezones);
    actions[handlers.timezones.add] = ({ commit }, timezone) => commit(handlers.timezones.add, timezone);
    actions[handlers.currentTimezone.set] = ({ commit }, currentTimezone) => commit(handlers.currentTimezone.set, currentTimezone);
};

const initMutations = function(mutations) {
    mutations[handlers.timezones.set] = (state, timezones) => (state.timezones = timezones);
    mutations[handlers.timezones.add] = (state, timezone) => (state.timezones.push(timezone));
    mutations[handlers.currentTimezone.set] = (state, currentTimezone) => (state.currentTimezone = currentTimezone);
};

let timezonesPromise = null;

const initAppState = function(appState, store) {
    appState.timezones = {
        get: () => store.getters.timezones,
        getTimezone: timezoneId => store.getters.timezones.filter(t => t.id === timezoneId)[0] || utcTimezone,
        ensure: () => {
            if (!timezonesPromise) {
                timezonesPromise = timezoneService.getAll();
                timezonesPromise.then(timezones => {
                    store.dispatch(handlers.timezones.set, timezones);
                });
            }
            return timezonesPromise;
        },
        add: (timezone) => {
            store.dispatch(handlers.timezones.add, timezone);
        }
    };
    appState.currentTimezone = {
        get: () => {
            let tz = store.getters.currentTimezone;
            if (!tz) {
                tz = localdataService.get('tz');
                if (tz) {
                    store.dispatch(handlers.currentTimezone.set, tz);
                }
            }
            return tz;
        },
        set: (currentTimezone) => {
            store.dispatch(handlers.currentTimezone.set, currentTimezone);
            localdataService.set('tz', currentTimezone);
        }
    },
    appState.browserTimezone = {
        get: () => {
            let tz = moment.tz.guess();
            let offset = moment().utcOffset();
            let sign = offset >= 0 ? '+' : '-';
            let time = moment(offset, 'minutes').format('HH:mm');
            return {
                id: tz,
                name: tz,
                description: `${tz} (${sign}${time})`,
                offset: offset
            }
        }
    }
};

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};



// WEBPACK FOOTER //
// ./_common/data/timezones.js